<template>
  <NavBurgerMenuUniverse id="shop" icon="Shop" :title="i18n(translations.shop)">
    <NavBurgerMenuHeader
      :color="activeCategory?.color"
      :title="activeCategory ? activeCategory.title : i18n(translations.shop)"
      @back="
        activeCategory ? (activeCategoryId = undefined) : clearActiveMenu()
      "
      @close="$emit('click-item')"
    />

    <ul v-if="!activeCategory" class="overflow-auto px-24 pb-32">
      <li v-for="item in shopItems" :key="item.id" class="py-20">
        <NavBurgerMenuItem
          :color="item.color"
          :icon="item.icon"
          :title="item.title"
          :url="item.url"
          @click-item="$emit('click-item')"
        />
      </li>
      <li v-for="category in categoryItems" :key="category.id" class="py-20">
        <NavBurgerMenuUniverseTrigger
          :image="category.image"
          :title="category.title"
          @click="activeCategoryId = category.id"
        />
      </li>
    </ul>

    <NavBurgerMenuCategoryDetail
      v-else
      :category="activeCategory"
      @click-item="$emit('click-item')"
    />
  </NavBurgerMenuUniverse>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { useActiveMenu } from '../../composables/useActiveMenu'
import type { NavigationItem } from '../../types'

import NavBurgerMenuCategoryDetail from './NavBurgerMenuCategoryDetail.vue'
import NavBurgerMenuHeader from './NavBurgerMenuHeader.vue'
import NavBurgerMenuItem from './NavBurgerMenuItem.vue'
import translations from './NavBurgerMenuShop.translations'
import NavBurgerMenuUniverse from './NavBurgerMenuUniverse.vue'
import NavBurgerMenuUniverseTrigger from './NavBurgerMenuUniverseTrigger.vue'

const props = defineProps<{
  shopItems: NavigationItem[]
  categoryItems: NavigationItem[]
}>()

defineEmits<{
  'click-item': []
}>()

const i18n = useI18n()
const { clearActiveMenu } = useActiveMenu()

// Local, not the global activeMenu, so opening a category doesn't close Shop.
const activeCategoryId = ref<string>()
const activeCategory = computed(() =>
  props.categoryItems.find(
    (category) => category.id === activeCategoryId.value,
  ),
)
</script>
